<template>
  <div class="contents shinsei-menu-container">
    <h2>各種申請 種別一覧</h2>
    <div class="container">
      <template v-if="isLoading">
        <template v-if="!isError">
          <loading :message="'データ読み込み中...'"></loading>
        </template>
      </template>

      <template v-else>
        <p class="aligncenter">作成したい申請を選択してください。</p>
        <div class="shinsei-menu page-menu-items" v-if="options">
          <div class="menu">
            <template v-for="(row, index) in options.shinsei_type" :key="index">
              <template v-if="row.annotation.length > 0">
                <template v-if="row.code">
                  <div class="col-item" >
                    <router-link :to="{
                      name: RouterConst.SHINSEI_CREATE,
                      params: { type: row.type, }
                    }">{{ row.label }}
                    </router-link>
                    <p>{{ row.annotation }}</p>
                </div>
                </template>
                <template v-else>
                  <div class="col-item" >
                    <router-link :to="{
                      name: RouterConst.SHINSEI_NO_APPROVAL,
                      params: { type: row.type, }
                    }">{{ row.label }}
                    </router-link>
                    <p>{{ row.annotation }}</p>
                </div>
                </template>
              </template>
            </template>
          </div>
        </div>

        <p v-else>現在申請はできません。</p>
      </template>
    </div>
  </div>
  <div class="button-container">
    <p class="prev-page">
      <a @click="router.go(-1)">戻る
      </a>
    </p>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { useInit } from '@/composable/shinsei/typelist/typelist';
import { RouterConst } from '@/const/Router';
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {

    // 初期化処理
    const { options, isLoading, isError } = useInit();

    const router = useRouter();

    return {
      options,
      isLoading,
      isError,
      RouterConst,
      router,
    }
  },
  components: {
  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/menu-items.scss";
</style>
